import { initializeApp } from 'firebase/app'

// todo externalize
const firebaseConfig = {
  apiKey: 'AIzaSyCzplANFRz1ZTv1O78C8UZhOYWcukz5Xes',
  authDomain: 'stammgast-gov-sk.firebaseapp.com',
  databaseURL: 'https://stammgast-gov-sk.firebaseio.com',
  projectId: 'stammgast-gov-sk',
  storageBucket: 'stammgast-gov-sk.appspot.com',
  messagingSenderId: '143462849118',
  appId: '1:143462849118:web:a7d12b3d35ea4bbec732cf',
  measurementId: 'G-M0728HEB6Q'
}

export default {
  init () {
    initializeApp(firebaseConfig)
  }
}
